<div class="article-card-container">
  @if (pageStyle !== "blogarticlelisting" && pageStyle !== "authorlisting") {
    <dotcom-frontend-link
      (click)="
        interactionClickEvent(article.contentLink.url, article.teaserTitle)
      "
      [arialabel]="article.teaserTitle"
      [linkClass]="'article-card box-shadow has-hover-shadow'"
      [url]="article.contentLink.url"
      class="article-card__link-container"
    >
      <div class="article-card__content--image">
        @if (article.teaserImage) {
          <dotcom-frontend-image
            [image]="article.teaserImage"
            class="article-card__image"
          />
        }
      </div>

      <div class="article-card__content--text">
        @if (article["category"] && pageStyle) {
          <div class="article-card__category">
            <span class="article-card__category--text">
              @for (category of article["category"]; let i = $index; let last = $last; track i) {
                {{ category.name }}@if (!last){,&nbsp;}
              }
            </span>
            @if (article.teaserIcon) {
              <lg-icon
                [name]="article.teaserIcon"
                class="article-card__category--icon"
              />
            }
          </div>
        }

        <h2
          class="article-card__title lg-font-size-4--medium lg-font--expressive"
        >
          {{ article.teaserTitle }}
        </h2>
        <span class="article-card__text">{{ article.teaserText }}</span>
      </div>
      @if (article["authorItems"] && pageStyle) {
        <div class="article-card__by-author">
          <div>
            by
            <span>
              @for (
                author of article["authorItems"];
                let i = $index;
                let last = $last;
                track i
              ) {
                {{ author.fullName }}@if (!last){, }
              }
            </span>
          </div>
        </div>
      }
    </dotcom-frontend-link>
  } @else {
    <div class="article-card box-shadow has-hover-shadow">
      <ng-container [ngTemplateOutlet]="articleCardContent"></ng-container>
    </div>
  }
</div>

<ng-template #articleCardContent>
  <div class="article-card__content--image">
    @if (article.teaserImage) {
      <dotcom-frontend-image
        [image]="article.teaserImage"
        class="article-card__image"
      />
    }
  </div>

  <div class="article-card__content--text">
    @if (pageStyle !== "blogarticlelisting" && pageStyle !== "authorlisting") {
      @if (article["category"]) {
        <div class="article-card__category">
          <span class="article-card__category--text">
            @for (category of article["category"]; let i = $index; let last=$last; track i) {
              {{ category.name }}@if (!last){,&nbsp;}
            }
          </span>
          @if (article.teaserIcon) {
            <lg-icon
              [name]="article.teaserIcon"
              class="article-card__category--icon"
            />
          }
        </div>
      }
    } @else {
      @if (category) {
        <div class="article-card__category">
          <dotcom-frontend-link
            (click)="interactionClickEvent(category.url, category.title)"
            [arialabel]="category.title"
            [url]="category.url"
            [linkClass]="'article-card__category-link'"
            >{{ category.title }}
          </dotcom-frontend-link>
        </div>
      }
    }

    <h2 class="article-card__title lg-font-size-4--medium lg-font--expressive">
      <dotcom-frontend-link
        (click)="
          interactionClickEvent(article.contentLink.url, article.teaserTitle)
        "
        [arialabel]="article.teaserTitle"
        [url]="article.contentLink.url"
        class="article-card__link"
      >
        {{ article.teaserTitle }}
      </dotcom-frontend-link>
    </h2>
    {{ truncateTeaserText(article.teaserText) }}
  </div>
  @if (article["authorItems"]) {
    <div class="article-card__authors-images">
      @for (
        authorImage of authorImages;
        let i = $index;
        let last = $last;
        track i
      ) {
        <dotcom-frontend-image
          [image]="authorImage"
          class="article-card__author-image"
        />
      }
    </div>
    <div class="article-card__by-author">
      <div class="article-card__authors-links">
        By&nbsp;
        <span>
          @for (
            author of article["authorItems"];
            let i = $index;
            let last = $last;
            track i
          ) {
            <dotcom-frontend-link
              (click)="interactionClickEvent(author.url, author.fullName)"
              [arialabel]="author.fullName"
              [linkClass]="'article-card__author-link'"
              [url]="author.url"
              >{{ author.fullName }}</dotcom-frontend-link
            >@if (!last) {, }
          }
        </span>
      </div>
    </div>
  }
  <div class="article-card__timestamp">
    <div class="article-card__timestamp-date">
      {{ date }}
    </div>
    @if (article.readTime && article.readTime > 0) {
      <div class="article-card__timestamp-readtime">
        <lg-icon [name]="'time'" class="article-card__timestamp-readtime-icon" />
        {{ article.readTime }} min read
      </div>
    }
  </div>
</ng-template>
